// src/layout/website/DefaultLayout.tsx
import React from 'react'; // Removed useState, useEffect
import { Outlet } from 'react-router-dom';
import StagingBanner from '../../components/website/StagingBanner';
import { shouldShowStagingBanner } from '../../config/environment';

export default function WebLayout() {
  const showBanner = shouldShowStagingBanner();

  // No dynamic padding needed for a corner overlay banner
  return (
    <div> {/* Removed style with paddingTop */}
      <Outlet />
      {showBanner && <StagingBanner />}
    </div>
  );
}